import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import locationPin from '~/images/address.svg';
import closeIcon from '~/images/close-button.svg';
import { toggleStoreAvailabilityModal } from '~/store/availability/actions';

const AvailabilityInStores = ({ product, availability }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const isAvailabilityModalOpen = useSelector(state => state.availabilityReducer.storeAvailabilityModalOpen);
	const color = availability?.Rows[0]?.Color?.split('-')[1] || '-';
	const size = availability?.Rows[0]?.Size?.split('-')[1] || '-';

	const closeModal = () => {
		document.body.classList.remove('toggle-store-availability-modal');
		dispatch(toggleStoreAvailabilityModal(false));
	};

	return (
		<div className={isAvailabilityModalOpen ? 'availability-modal availability-content' : 'availability-modal'}>
			<main>
				<div className="availability">
					<h2 className="top-message">{t('availability_stores')}</h2>
					<button className="close-btn" onClick={closeModal}>
						<img src={closeIcon} alt={product?.nm} />
					</button>
				</div>

				<div className="availability-main">
					<div className="image-name-price">
						<div className="image">
							<img src={product?.img1} alt={product?.nm} />
						</div>
						<div className="product-info">
							<h3 className="product-name">{product.nm}</h3>
							<h4 className="product-price">{product?.prc} € </h4>
							{/* 	<p className="retail-price">
							Προτεινόμενη Τιμή Λιανικής {product?.prc2} € ({Math.round(((product.prc2 - product.prc) / product.prc2) * 100)}%)
						</p> */}
						</div>
					</div>
					<div className="description-stores">
						<p className="description">
							<Trans i18nKey="product_available_in_stores" values={{ name: product.nm, color, size }} components={{ b: <b /> }} />
						</p>

						{availability?.Rows?.length > 0 ? (
							availability.Rows.map((store, index) => (
								<div className="store" key={index}>
									<h3>{store.nm}</h3>
									<div className="store-address">
										<img src={locationPin} alt={'location-icon'} width={16} height={16} />
										<p>{store.adl}</p>
									</div>
									<p className="availability-status">{store.Availability}</p>
								</div>
							))
						) : (
							<p className="availability-status no-availability">{t('availability_online_only')}</p>
						)}
					</div>
				</div>
			</main>
		</div>
	);
};

export default AvailabilityInStores;
